import { createContext, useContext, useMemo } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import client from "../../graphql";
import { useLocalStorage } from "./useLocalStorage";

const AuthContext = createContext<any>(null!);

export const AuthProvider = ({ children }: any) => {
    const [user, setUser] = useLocalStorage("_token", null);
    const navigate = useNavigate();

    const login = async (data: any) => {
        setUser(data);
    };

    const logout = () => {
        setUser(null);
        client.resetStore();
        localStorage.removeItem('_token');
        localStorage.removeItem('isTeacher');
        navigate("/login", { replace: true });
    };

    const value = useMemo(
        () => ({
            user,
            login,
            logout
        }),// eslint-disable-next-line
        [user]
    );
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};

export const ProtectedRoute = ({ children }: any) => {
    const { user } = useAuth();
    if (!user) {
        // user is not authenticated
        return <Navigate to="/login" />;
    }
    return children;
};

export const LoginRoute = ({ children }: any) => {
    const { user } = useAuth();
    if (user) {
        // user is authenticated
        return <Navigate to="/" />;
    }
    return children;
};
